import { createStore,combineReducers } from 'redux';
import userInfo from './userInfo';
import commonInfo from './commonInfo';

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
 
const persistConfig = {
    key: 'root',
    storage,
}
  
const rootReducer = combineReducers({
    userInfo: persistReducer(persistConfig, userInfo),
    commonInfo: persistReducer(persistConfig, commonInfo)
})
  
export const store=createStore(rootReducer);
export const persistor=persistStore(store);
export default rootReducer;